import React from "react";
import Layout from "../layout";
import Seo from "../layout/seo";
import AllRecipes from "../components/allRecipes";
import "../styles/main.scss";

const Recettes = () => {
  return (
    <Layout>
      <Seo />
      <AllRecipes />
    </Layout>
  );
};

export default Recettes;
